var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import FacebookLogin from "react-facebook-login";
import { connect } from "react-redux";
import { IdPersistence } from "../../constants/IdPersistence";
import { IdSocialMedia } from "../../constants/IdSocialMedia";
import { selectPlayerFbConnected } from "../../selectors/selectFbConnectedAccountInfo";
import { globalConfig } from "../../setup/globalConfig";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { PersistenceMode } from "../../utils/PersistenceMode";
import { utilEnvironment } from "../../utils/utilEnvironment";
import { utilPersistence } from "../../utils/utilPersistence";
import { actionFacebookRequestInfo, actionPlayerInfoDisconnected } from "./actionFacebookConnect";
import { IdFacebookStatus } from "./IdFacebookStatus";
var FB = "FB";
var HudButtonFacebookConnectDOM = /** @class */ (function (_super) {
    __extends(HudButtonFacebookConnectDOM, _super);
    function HudButtonFacebookConnectDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            autoLoad: false,
        };
        _this.connectFB = function (response) {
            var onRequestInfo = _this.props.onRequestInfo;
            var fbToken = response.accessToken;
            if (!utilEnvironment.isDevelopment()) {
                utilPersistence.setValue(IdPersistence.Credentials, { fbToken: fbToken }, PersistenceMode.Update);
            }
            onRequestInfo();
        };
        _this.failureResponseFacebook = function (response) {
            _this.setState({
                autoLoad: false,
            });
        };
        _this.disconnectFB = function () {
            window[FB].logout(function (fbResponse) {
                if (fbResponse.status !== IdFacebookStatus.connected) {
                    _this.logoutSuccess();
                }
            });
        };
        _this.checkLoginStatus = function () {
            if (_this.state.autoLoad) {
                return;
            }
            window[FB].getLoginStatus(function (fbResponse) {
                if (!fbResponse && fbResponse.status) {
                    return;
                }
                if (fbResponse.status === IdFacebookStatus.connected &&
                    utilPersistence.getValue(IdPersistence.FbConnected, false)) {
                    // USER IS LOGGED IN AND HAS AUTHORIZED APP
                    _this.setState({
                        autoLoad: true,
                    });
                }
                else if (fbResponse.status === IdFacebookStatus.notAuthorized) {
                    // USER IS LOGGED IN TO FACEBOOK (BUT HASN'T AUTHORIZED YOUR APP YET)
                    utilPersistence.setValue(IdPersistence.FbConnected, false, PersistenceMode.Write);
                }
            });
        };
        _this.logoutSuccess = function () {
            var disconnectFb = _this.props.disconnectFb;
            disconnectFb();
            utilPersistence.setValue(IdPersistence.FbConnected, false, PersistenceMode.Write);
        };
        return _this;
    }
    HudButtonFacebookConnectDOM.prototype.render = function () {
        var _a = this.props, isSdkLoaded = _a.isSdkLoaded, isFbConnected = _a.isFbConnected;
        var autoLoad = this.state.autoLoad;
        if (isSdkLoaded && !isFbConnected) {
            this.checkLoginStatus();
        }
        var buttonStyle = {
            border: "2px solid #3a3a3a",
            borderRadius: "10px",
            boxShadow: "0 3px 0 rgba(0, 0, 0, 0.4), inset 0 -3px 0 0 rgba(0, 0, 0, 0.2)",
            cursor: "url(" + globalConfig.assetConfig.cursorUrl + "), pointer",
            height: "65px",
            width: "238px",
        };
        return (React.createElement(FacebookLogin, { appId: IdSocialMedia.FacebookAppId, autoLoad: autoLoad, buttonStyle: buttonStyle, fields: "name,email", textButton: isFbConnected
                ? utilLoca.get(IdLoca.settingsMenu_connected)
                : utilLoca.get(IdLoca.settingsMenu_disconnected), icon: "fa-facebook", cookie: true, callback: isFbConnected ? this.disconnectFB : this.connectFB, onFailure: this.failureResponseFacebook }));
    };
    return HudButtonFacebookConnectDOM;
}(React.Component));
var mapState = function (state) { return ({
    isFbConnected: selectPlayerFbConnected(state),
    isSdkLoaded: !!window[FB],
}); };
var mapDispatch = function (dispatch) { return ({
    disconnectFb: function () { return dispatch(actionPlayerInfoDisconnected()); },
    onRequestInfo: function () { return dispatch(actionFacebookRequestInfo()); },
}); };
export var HudButtonFacebookConnect = connect(mapState, mapDispatch)(HudButtonFacebookConnectDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/HudButtonFacebookConnect.tsx
// module id = 2748
// module chunks = 3